import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar.js';
import { TopBar } from './TopBar.js';
import { useSidebar } from '../hooks/useSidebar.js';

export function AppLayout() {
  const { collapsed } = useSidebar();
  const sidebarWidth = collapsed ? '4rem' : '15rem';

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100">
      <Sidebar />
      <div
        className="transition-[margin-left] duration-200"
        style={{ marginLeft: `var(--sidebar-width, 0px)` }}
      >
        <TopBar />
        <main className="px-6 py-6">
          <Outlet />
        </main>
      </div>
      <style>{`
        @media (min-width: 1024px) {
          :root { --sidebar-width: ${sidebarWidth}; }
        }
        @media (max-width: 1023px) {
          :root { --sidebar-width: 0px; }
        }
      `}</style>
    </div>
  );
}
